import { formatDistanceToNow } from "date-fns";
import { formatNumber } from "@/lib/utils";
import type { UserProfile } from "../utils";

interface ProfileStatsProps {
  profile: UserProfile;
}

const STAT_ITEMS = [
  { key: "totalWeaponBuilds", label: "BUILDS" },
  { key: "totalLoadouts", label: "LOADOUTS" },
  { key: "totalTierLists", label: "TIER LISTS" },
] as const;

export function ProfileStats({ profile }: ProfileStatsProps) {
  return (
    <div className="flex justify-center gap-[22px] font-mono sm:justify-start sm:pb-1.5">
      {STAT_ITEMS.map((item) => (
        <div className="text-center" key={item.key}>
          <div className="font-bold text-2xl text-[#46C8E0]">
            {formatNumber(profile.stats[item.key])}
          </div>
          <div className="mt-0.5 text-[#6a7075] text-[10px] tracking-wider">
            {item.label}
          </div>
        </div>
      ))}

      {profile.lastSignInAt ? (
        <div className="border-[#1c1f22] border-l pl-[22px] text-center">
          <div className="text-[#8B9297] text-xs">Last seen</div>
          <div className="mt-0.5 text-[#6a7075] text-[10px]">
            {formatDistanceToNow(profile.lastSignInAt, {
              addSuffix: true,
            })}
          </div>
        </div>
      ) : null}
    </div>
  );
}
